(() => {
  const initContact = (root) => {
    if (!root || root.dataset.ynzcInitialized === 'true') return;
    root.dataset.ynzcInitialized = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || root.dataset.motion === 'false';
    const menuToggle = root.querySelector('[data-ynzc-menu-toggle]');
    const nav = root.querySelector('[data-ynzc-nav]');
    const header = root.querySelector('[data-ynzc-header]');
    const briefSection = root.querySelector('[data-ynzc-brief]');

    const closeMenu = () => {
      if (!menuToggle || !nav) return;
      nav.classList.remove('is-open');
      menuToggle.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', menuToggle.dataset.openLabel || 'Abrir menú');
      document.body.classList.remove('ynzc-menu-open');
    };

    if (menuToggle && nav) {
      menuToggle.addEventListener('click', () => {
        const open = nav.classList.toggle('is-open');
        menuToggle.classList.toggle('is-open', open);
        menuToggle.setAttribute('aria-expanded', String(open));
        menuToggle.setAttribute('aria-label', open ? (menuToggle.dataset.closeLabel || 'Cerrar menú') : (menuToggle.dataset.openLabel || 'Abrir menú'));
        document.body.classList.toggle('ynzc-menu-open', open);
      });
      nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      window.addEventListener('resize', () => {
        if (window.innerWidth > 1180) closeMenu();
      }, { passive: true });
    }

    if (header && header.dataset.sticky === 'true') {
      const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
      syncHeader();
      window.addEventListener('scroll', syncHeader, { passive: true });
    }

    const routeButtons = [...root.querySelectorAll('[data-ynzc-route]')];
    const routeField = root.querySelector('[data-ynzc-route-field]');
    const projectChoices = [...root.querySelectorAll('[data-ynzc-choice]')];
    const conditionalSection = root.querySelector('[data-ynzc-conditional]');
    const mixContextTitle = root.querySelector('[data-ynzc-mix-title]');
    const generalMessageTitle = root.querySelector('[data-ynzc-general-title]');
    const mixContextFields = [...root.querySelectorAll('[data-ynzc-mix-field]')];
    const templateProductCard = root.querySelector('[data-ynzc-template-card]');
    const contactBudget = root.querySelector('[data-ynzc-budget]');
    const contactTimeline = root.querySelector('[data-ynzc-timeline]');
    const contactMessage = root.querySelector('[data-ynzc-message]');
    const contactMessageField = root.querySelector('[data-ynzc-message-field]');
    const contactMessageLabel = root.querySelector('[data-ynzc-message-label]');
    const contactMessageHelp = root.querySelector('[data-ynzc-message-help]');
    const formActions = root.querySelector('[data-ynzc-form-actions]');
    const contactConsent = root.querySelector('[data-ynzc-consent]');
    let conditionalWasVisible = false;

    const animateConditionalEntry = () => {
      if (!conditionalSection || reduceMotion || conditionalWasVisible) return;
      conditionalSection.animate(
        [
          { opacity: 0, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 300, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
      );
      conditionalWasVisible = true;
    };

    const updateContactPath = () => {
      const selectedChoice = projectChoices.find((choice) => choice.checked);
      const behavior = selectedChoice?.dataset.behavior || '';
      const isMix = behavior === 'mix';
      const isTemplate = behavior === 'template';
      const needsMessage = Boolean(selectedChoice) && !isTemplate;

      if (conditionalSection) conditionalSection.hidden = !selectedChoice;
      if (mixContextTitle) mixContextTitle.hidden = !isMix;
      if (generalMessageTitle) generalMessageTitle.hidden = !needsMessage || isMix;
      mixContextFields.forEach((field) => { field.hidden = !isMix; });
      if (templateProductCard) templateProductCard.hidden = !isTemplate;
      if (contactBudget) contactBudget.disabled = !isMix;
      if (contactTimeline) contactTimeline.disabled = !isMix;
      if (contactMessageField) contactMessageField.hidden = !needsMessage;
      if (contactMessage) contactMessage.disabled = !needsMessage;
      if (formActions) formActions.hidden = isTemplate;
      if (contactConsent) contactConsent.disabled = isTemplate;

      if (selectedChoice && contactMessage && contactMessageLabel && contactMessageHelp) {
        contactMessageLabel.textContent = selectedChoice.dataset.messageLabel || contactMessageLabel.dataset.defaultLabel || '';
        contactMessage.placeholder = selectedChoice.dataset.messagePlaceholder || '';
        contactMessageHelp.textContent = selectedChoice.dataset.messageHelp || '';
      }

      if (selectedChoice) animateConditionalEntry();
      else conditionalWasVisible = false;
    };

    projectChoices.forEach((choice) => {
      choice.addEventListener('change', () => {
        updateContactPath();
        updateProgress();
      });
    });

    routeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        routeButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });

        if (routeField) routeField.value = button.dataset.routeValue || '';
        const prefill = button.dataset.prefill || '';
        if (prefill) {
          const matchingChoice = projectChoices.find((choice) => choice.dataset.behavior === prefill);
          if (matchingChoice) matchingChoice.checked = true;
        }

        updateContactPath();
        updateProgress();
        briefSection?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    const characterCount = root.querySelector('[data-ynzc-character-count]');
    if (contactMessage && characterCount) {
      const syncCharacterCount = () => { characterCount.textContent = String(contactMessage.value.length); };
      contactMessage.addEventListener('input', syncCharacterCount);
      syncCharacterCount();
    }

    const form = root.querySelector('.ynzc-contact-form');
    const progressBar = root.querySelector('[data-ynzc-progress-bar]');
    const progressLabel = root.querySelector('[data-ynzc-progress-label]');

    function updateProgress() {
      if (!form) return;
      const selectedChoice = projectChoices.find((choice) => choice.checked);
      if (selectedChoice?.dataset.behavior === 'template') {
        progressBar?.style.setProperty('--ynzc-progress', '1');
        if (progressLabel) progressLabel.textContent = progressLabel.dataset.productReady || 'PRODUCTO LISTO';
        return;
      }

      const checks = [
        Boolean(root.querySelector('[data-ynzc-name]')?.value.trim()),
        Boolean(root.querySelector('[data-ynzc-email]')?.value.trim()),
        Boolean(selectedChoice),
        Boolean(contactMessage?.value.trim()),
        Boolean(contactConsent?.checked)
      ];
      const percent = Math.round((checks.filter(Boolean).length / checks.length) * 100);
      progressBar?.style.setProperty('--ynzc-progress', String(percent / 100));
      if (progressLabel) progressLabel.textContent = `${percent}% ${progressLabel.dataset.suffix || 'COMPLETADO'}`;
    }

    if (form) {
      form.addEventListener('input', updateProgress);
      form.addEventListener('change', updateProgress);
    }

    const faqItems = [...root.querySelectorAll('[data-ynzc-faq]')];
    faqItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faqItems.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    const revealItems = root.querySelectorAll('[data-ynzc-reveal]');
    if (!reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('ynzc-motion-ready');
      const observer = new IntersectionObserver((entries, revealObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    updateContactPath();
    updateProgress();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-ynz-contact]').forEach(initContact);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
